import React from 'react';

import { HelmetProvider } from 'react-helmet-async';
import { SettingsProvider } from './SettingsContext';
import { CollapseDrawerProvider } from './CollapseDrawerContext';
import { AuthProvider } from './JWTContext';
import { ModalContextProvider } from './Modal';

function Providers({ children }) {
  return (
    <AuthProvider>
      <HelmetProvider>
        <SettingsProvider>
          <CollapseDrawerProvider>
            <ModalContextProvider>{children}</ModalContextProvider>
          </CollapseDrawerProvider>
        </SettingsProvider>
      </HelmetProvider>
    </AuthProvider>
  );
}

export default Providers;
